import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'

type CalendarToolbarView = {
  label: string
  value: string
}

type MobileCalendarToolbarProps = {
  currentView: string
  title: string
  views: CalendarToolbarView[]
  onNext: () => void
  onPrev: () => void
  onToday: () => void
  onViewChange: (view: string) => void
}

export function MobileCalendarToolbar({
  currentView,
  title,
  views,
  onNext,
  onPrev,
  onToday,
  onViewChange,
}: MobileCalendarToolbarProps) {
  const headerButtonClassName =
    'h-8 rounded-md border-border bg-background px-2 py-1 text-xs font-medium text-foreground shadow-none hover:bg-muted hover:text-foreground'
  const activeHeaderButtonClassName = `${headerButtonClassName} bg-muted`

  return (
    <>
      <div className="px-3 py-3 sm:px-0 sm:py-0">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0 flex-1">
            <p className="text-base font-semibold capitalize leading-none sm:text-lg">{title}</p>
          </div>

          <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              className={headerButtonClassName}
              onClick={onToday}
            >
              Heute
            </Button>

            {views.map((view) => (
              <Button
                key={view.value}
                type="button"
                variant="outline"
                className={
                  currentView === view.value
                    ? activeHeaderButtonClassName
                    : headerButtonClassName
                }
                onClick={() => onViewChange(view.value)}
              >
                {view.label}
              </Button>
            ))}
          </div>
        </div>
      </div>

      <div className="pointer-events-none fixed bottom-[calc(env(safe-area-inset-bottom)+4.5rem)] right-4 z-30 flex items-center gap-2">
        <Button
          type="button"
          size="icon"
          variant="outline"
          className="pointer-events-auto h-11 w-11 rounded-full border-border/50 bg-background/55 shadow-lg backdrop-blur supports-[backdrop-filter]:bg-background/40"
          onClick={onPrev}
          aria-label="Vorheriger Zeitraum"
        >
          <ChevronLeftIcon className="h-4 w-4" />
        </Button>
        <Button
          type="button"
          size="icon"
          variant="outline"
          className="pointer-events-auto h-11 w-11 rounded-full border-border/50 bg-background/55 shadow-lg backdrop-blur supports-[backdrop-filter]:bg-background/40"
          onClick={onNext}
          aria-label="Nächster Zeitraum"
        >
          <ChevronRightIcon className="h-4 w-4" />
        </Button>
      </div>
    </>
  )
}
